import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { AuthType, ConnectionStatus } from '../../../lib/enums';
import gaDataLayerEvent from '../../../lib/hooks/GA/gaDataLayerEvent';
import { useAuth } from '../../../lib/providers/authProvider';
import { useAuthType } from '../../../lib/providers/authTypeState';
import Program from 'wwg-utilities/dist/collections/program';
import Provider from 'wwg-utilities/dist/collections/provider';
import createTrainingConnectionRequest from '../../../lib/api/createTrainingConnectionRequest';
import sendGetStartedEmailRequest from '../../../lib/api/sendGetStartedEmailRequest';
import frontendURL from '../../../lib/config/project/frontendURL';
import { isSkillup } from '../../../lib/config/project/project';
import getProgramSlug from '../../../lib/data/getProgramSlug';

interface GetStartedButtonProps {
  program: Program;
  small?: boolean;
  location: 'top' | 'bottom' | 'profile';
}

const GetStartedButton: React.FC<GetStartedButtonProps> = ({
  program,
  small,
  location,
}) => {
  const getStartedUrl =
    program.applicationData?.applicationURL || program.contactData?.url || '';
  const { seeker, user } = useAuth();
  const { setAuthType } = useAuthType();
  const programUrl = useRef(
    `${frontendURL}/training${getProgramSlug(program)}`,
  );
  useEffect(() => {
    if (!getStartedUrl) {
      toast.error('No get started URL.');
    }
  }, [getStartedUrl]);

  const handleGetStartedClicked = async () => {
    await createTrainingConnectionRequest(
      seeker?.id,
      program.id,
      ConnectionStatus.ClickededGetStarted,
      (program.institution as Provider).id,
      `${seeker?.firstName} ${seeker?.lastName} <> ${program.name} at ${
        (program.institution as Provider).name
      } `,
      program.catalog || [],
    );
    const firstName =
      seeker?.firstName || (seeker?.name as string).split(' ')[0];
    if (!isSkillup) {
      await sendGetStartedEmailRequest(
        firstName,
        program.name,
        (program.institution as Provider).name,
        programUrl.current,
        getStartedUrl,
        seeker?.email as string,
      );
    }
    gaDataLayerEvent({
      event: 'get_started_cta',
      cta_location: location,
      program_title: `${program.name} at ${
        (program.institution as Provider).name
      }`,
    });
    gaDataLayerEvent({
      event: 'cta_interaction',
      cta_interaction: 'cta_clicked_get_started',
    });
  };

  if (!seeker && !user) {
    return (
      <button
        onClick={() => {
          gaDataLayerEvent({
            event: 'get_started_cta',
            cta_location: location,
            program_title: `${program.name} at ${
              (program.institution as Provider).name
            }`,
          });
          gaDataLayerEvent({
            event: 'cta_interaction',
            cta_interaction: 'cta_clicked_get_started',
          });
          setAuthType(AuthType.Login);
        }}
        className={`${
          small ? 'px-4 text-sm font-bold py-3.5' : 'p-4 text-base md:text-xl'
        } 
                    flex items-center justify-center text-white hover:text-save-button rounded-full font-bold bg-save-button hover:bg-white border-2 border-solid border-save-button w-full font-base `}
      >
        Get Started
      </button>
    );
  }
  return (
    <button
      className={`flex items-center justify-center rounded-full text-white hover:text-save-button border-2 border-solid border-save-button font-bold bg-save-button hover:bg-white w-full ${small}`}
    >
      <Link
        target="_blank"
        className={`${
          small ? 'px-3 text-sm font-bold py-2' : 'p-4 text-base md:text-xl'
        } font-base text-white w-full hover:text-save-button`}
        onClick={handleGetStartedClicked}
        href={getStartedUrl}
      >
        Get Started
      </Link>
    </button>
  );
};

export default GetStartedButton;
